import { Suspense } from 'react'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import styled from 'styled-components'
import Header from '../components/Header'
import Popups from '../components/Popups'
import BlockNumber from '../components/BlockNumber'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import AddLiquidity from './AddLiquidity'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity
} from './AddLiquidity/redirects'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'
import { RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 160px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
      padding: 16px;
  `};

  z-index: 1;
`

const Marginer = styled.div`
  margin-top: 5rem;
`

export default function App() {
  return (
    <Suspense fallback={null}>
      <HashRouter>
        <DarkModeQueryParamReader />
        <AppWrapper>
          <HeaderWrapper>
            <Header />
          </HeaderWrapper>
          <BodyWrapper>
            <Popups />
            <Routes>
              <Route path="/swap" element={<Swap />} />
              <Route path="/swap/:outputCurrency" element={<RedirectToSwap />} />
              <Route path="/send" element={<RedirectPathToSwapOnly />} />
              <Route path="/find" element={<PoolFinder />} />
              <Route path="/pool" element={<Pool />} />
              <Route path="/create" element={<RedirectToAddLiquidity />} />
              <Route path="/add" element={<AddLiquidity />} />
              <Route path="/add/:currencyIdA" element={<RedirectOldAddLiquidityPathStructure />} />
              <Route path="/add/:currencyIdA/:currencyIdB" element={<RedirectDuplicateTokenIds />} />
              <Route path="/remove/:tokens" element={<RedirectOldRemoveLiquidityPathStructure />} />
              <Route path="/remove/:currencyIdA/:currencyIdB" element={<RemoveLiquidity />} />
              <Route path="*" element={<Navigate to="/swap" replace />} />
            </Routes>
            <Marginer />
          </BodyWrapper>
          <BlockNumber />
        </AppWrapper>
      </HashRouter>
    </Suspense>
  )
}
